var exports = {
  "k": "x127c5a35--d51dbd--container",
};

module.exports = exports;
